import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Injectable } from '@angular/core';
import { apiUrl } from '../constants/apiUrl';
import { HttpRequestService } from '../services/http-request.service';
import { encryptAES } from '../utils/cipher';

@Injectable({
    providedIn: 'root',
})
export class AuthApi {
    constructor(private httpRequestService: HttpRequestService) {}

    async login(param: LoginRequestType): Promise<LoginResponseType> {
        try {
            const result = await this.httpRequestService.axiosPost(
                apiUrl.login,
                {
                    username: encryptAES(param.username),
                    password: encryptAES(param.password),
                    // ...param
                }
            );
            const response = {
                data: result.data,
                status: result.status,
                message: '',
            };
            return response;
        } catch (error) {
            return error.toString();
        }
    }

    async resendEmail(param: ResendEmailRequestType) {
        try {
            const result = await this.httpRequestService.axiosPost(
                apiUrl.resendEmail,
                param
            );

            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async register(param: RegisterRequestType): Promise<RegisterResponseType> {
        try {
            const result = await this.httpRequestService.axiosPost(
                apiUrl.register,
                param
            );
            const response = {
                data: result.data,
                status: result.status,
                message: '',
            };
            return response;
        } catch (error) {
            return error.toString();
        }
    }

    // async registerLegal(
    //     param: RegisterLegalRequestType
    // ): Promise<RegisterLegalResponseType> {
    //     try {
    //         const result = await this.httpRequestService.axiosPost(
    //             apiUrl.registerLegal,
    //             param
    //         );
    //         const response = {
    //             data: result.data,
    //             status: result.status,
    //             message: '',
    //         };
    //         return response;
    //     } catch (error) {
    //         return error.toString();
    //     }
    // }

    async forgetPassword(param: ForgetPasswordRequestType) {
        try {
            const result = await this.httpRequestService.axiosPost(
                apiUrl.forgetPassword,
                param
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async changePassword(param: ChangePasswordRequestType) {
        try {
            const result = await this.httpRequestService.axiosPut(
                apiUrl.changePassword,
                param
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async userExist(
        param: UserExistRequestType
    ): Promise<UserExistResponseType> {
        try {
            const result = await this.httpRequestService.axiosPost(
                apiUrl.userExist,
                param
            );
            const response = {
                data: result.data,
                status: result.status,
                message: '',
            };
            return response;
        } catch (error) {
            return error.toString();
        }
    }

    async verifyEmail(token: string) {
        try {
            const result = await this.httpRequestService.axiosGet(
                apiUrl.verify.replace('{token}', token)
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async verifyForget(token: string) {
        try {
            const result = await this.httpRequestService.axiosGet(
                apiUrl.verifyForget.replace('{token}', token)
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async setPassword(param: ChangePasswordRequestType) {
        try {
            const result = await this.httpRequestService.axiosPut(
                apiUrl.setPassword,
                param
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async getMenuPermission() {
        const result = await this.httpRequestService.axiosGetWithToken(
            apiUrl.menuPermission
        );
        return result.data;
    }

    async getMenuByToken(token: string) {
        const config: AxiosRequestConfig<any> = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const result = await this.httpRequestService.axiosGet(
            apiUrl.menuPermission,
            config
        );
        return result.data;
    }

    async getAdministrative(provCode?: string, districtCode?: string) {
        let url = new URL(apiUrl.administrative);
        if (provCode) url.searchParams.set('provCode', provCode.toString());
        if (districtCode)
            url.searchParams.set('districtCode', districtCode.toString());

        const result = await this.httpRequestService.axiosGet(url.toString());
        const response = result.data.map((item) => {
            return { id: item.code, name: item.name };
        });
        return response;
    }

    async profileChangePassword(data: ProfileChangePasswordRequestType) {
        try {
            const result = await this.httpRequestService.axiosPostWithToken(
                apiUrl.profileChangePassword,
                {
                    oldPassword: encryptAES(data.oldPassword),
                    newPassword: encryptAES(data.newPassword),
                }
                // data
            );
            return result.data;
        } catch (error) {
            return error.toString();
        }
    }

    async resendMail(param: ResendEmailRequestType) {
        try {
            const result = await this.httpRequestService.axiosPost(
                apiUrl.resendEmail,
                param
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async checkOwnerExist() {
        try {
            const result = await this.httpRequestService.axiosGetWithToken(
                apiUrl.ownerExist
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async getOwnerNames() {
        try {
            const result = await this.httpRequestService.axiosGetWithToken(
                apiUrl.ownerNames
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }

    async checkUserOwnerExistByIdCard(idCard: string) {
        try {
            const result = await this.httpRequestService.axiosGet(
                apiUrl.userOwnerExistByIdCard.replace('{idCard}', idCard)
            );
            return result;
        } catch (error) {
            return error.toString();
        }
    }
}
